import createModel from './lib/create_model';

const AITransfer = createModel({
  modelName: 'AITransfer',

  properties: {},

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default AITransfer;
